import "./App.css";
import HomeDashboard from "./component/Dashboard/UserDashboard/HomeDashboard/HomeDashboard";
import Footer from "./component/Shard/Footer/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "./component/Home/Home";
import RequestQuoteAfter from "./component/RequestQuote/RequestQuoteAfter";
import RequestQuote from "./component/RequestQuote/RequestQuote";
import CustomerREQ from "./component/Dashboard/AdminDashboard/CustomerREQ/CustomerREQ";
import Chart from "./component/Dashboard/AdminDashboard/Chart/Chart";
import REQ from "./component/Dashboard/AdminDashboard/Req/REQ";
import ReqForChange from "./component/Dashboard/UserDashboard/Service/Pages/ReqForChange";
import UserTab from "./component/Dashboard/UserDashboard/UserTab/UserTab";
import ViewQuotes from "./component/Dashboard/UserDashboard/Service/Pages/ViewQuotes";
import AdminViewQuote from "./component/Dashboard/AdminDashboard/ViewQuote/AdminViewQuote";
import ProductDetails from "./component/RequestQuote/ProdectDetails";
import UserClosed from "./component/Dashboard/UserDashboard/Service/Pages/UserClosed";
import Booking from "./component/Pages/Booking";
import Modal from "./component/Modal/Modal";
import LoginModal from "./component/Modal/LoginModal";
import SubmitAfterModal from "./component/Modal/SubmitAfterModal";
import Rejects2 from "./component/Dashboard/UserDashboard/Service/RoadTransport/accpentAndReject/Rejects2";
import Approve2 from "./component/Dashboard/UserDashboard/Service/RoadTransport/accpentAndReject/Approve2";

function App() {
  const [shaw, setIsShaw] = useState(true);
  const [isShaws, setIsShaws] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [afterSubmitModalOpen, setAfterSubmitModalOpen] = useState(false);

  return (
    <div>
      <Router>
        {/* <Navbar isShaw={isShaw} setIsShaw={setIsShaw} /> */}
        {modalOpen && (
          <Modal
            setModalOpen={setModalOpen}
            setAfterSubmitModalOpen={setAfterSubmitModalOpen}
          />
        )}
        {loginModalOpen && (
          <LoginModal
            setLoginModalOpen={setLoginModalOpen}
            setAfterSubmitModalOpen={setAfterSubmitModalOpen}
          />
        )}
        {afterSubmitModalOpen && (
          <SubmitAfterModal setAfterSubmitModalOpen={setAfterSubmitModalOpen} />
        )}

        <Routes>
          <Route
            path="/"
            element={
              <Home
                isShaw={shaw}
                setIsShaw={setIsShaw}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                setLoginModalOpen={setLoginModalOpen}
              />
            }
          />
          <Route
            path="/request1"
            element={<RequestQuoteAfter isShaw={shaw} setIsShaw={setIsShaw} />}
          />

          <Route
            path="/booking"
            element={<Booking isShaw={shaw} setIsShaw={setIsShaw} />}
          />

          <Route
            path="/prodect-details"
            element={<ProductDetails isShaw={shaw} setIsShaw={setIsShaw} />}
          />
          <Route
            path="/request-a-quote"
            element={
              <RequestQuote
                isShaw={shaw}
                setIsShaw={setIsShaw}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                setLoginModalOpen={setLoginModalOpen}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <HomeDashboard isShaws={isShaws} setIsShaws={setIsShaws} />
            }
          >
            <Route
              path="/dashboard/customer"
              element={<CustomerREQ isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard"
              element={<Chart isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/req"
              element={<REQ isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/admin-quotes"
              element={
                <AdminViewQuote isShaws={isShaws} setIsShaw={setIsShaw} />
              }
            ></Route>
            {/* user dash board component */}
            <Route
              path="/dashboard/my-req"
              element={<UserTab isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/req-for-change"
              element={<ReqForChange isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/closed"
              element={<UserClosed isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/quotes"
              element={<ViewQuotes isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/reject"
              element={<Rejects2 isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/approve"
              element={<Approve2 isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
          </Route>
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
